export default "__VITE_ASSET__DeAiD7D9__"